import * as signalR from "@microsoft/signalr";
import { API_BASE_URL } from "@/services/api";

const hubsUrl = () => new String(API_BASE_URL).replace("/api", "/selectHub");

const getSignalRConnection = () => {
  return new signalR.HubConnectionBuilder()
    .withUrl(hubsUrl(), { withCredentials: true })

    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();
};

export default getSignalRConnection;
